import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ZpDataService } from "./../../services/zp-data.service";
import { UserInfoService } from "./../../services/user-info.service";
import { SideNavBarVisibilityService } from "./../../services/side-nav-bar-visibility.service";
import { UserIdleService } from "angular-user-idle";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"],
})
export class LoginComponent implements OnInit {
  public loginForm: FormGroup;
  public mfaForm: FormGroup;
  public loader = false;
  public submitted = false;
  public returnUrl: string;
  public error = "";
  public authenticationService: any;
  public alertService: any;
  public id: any;
  public loginFail: boolean = false;
  public MFAFail: boolean = false;
  public hasSharedPlans = false;
  public hasPlan: any;
  public mySharedPlans: {}[];
  public isProfessional: boolean;
  public doMFA = false;
  public MFAEmpty: boolean = false;
  public statusPassword: any;
  public capsOn: any;
  public myUser: any;
  public disabled: boolean;
  public currentURL: string;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  
  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private ZpDataService: ZpDataService,
    private userInfo: UserInfoService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private userIdle: UserIdleService,
    public themeService: ThemeService
  ) {
    this.currentURL = window.location.href;
  }

  ngOnInit() {
    this.sideNavBarVisibilityService.hideSideNav = true;
    this.loginForm = this.formBuilder.group({
      userName: ["", [Validators.required, Validators.email]],
      password: ["", Validators.required],
    });
    this.mfaForm = this.formBuilder.group({
      mfaCode: ["", [Validators.required]],
    });
    this.userInfo.changeMessage("");
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.theme != 'default') {
      this.isDefaultTheme = false;
      console.log('isDefaultTheme: ', this.isDefaultTheme)
    }
  }

  get f() {
    return this.loginForm.controls;
  }

  get mf() {
    return this.mfaForm.controls;
  }

  get isSMS() {
    if (this.myUser && this.myUser.mfaVia && this.myUser.mfaVia === "SMS") {
      return true;
    }
    return false;
  }

  async completeLogin() {
    this.loader = true;
    if (this.id) {
      this.myUser = await this.ZpDataService.getItemUser(this.id, "users");
      let subscriptionStatus = await this.ZpDataService.getSubscriptionStatus();
      if (
        this.ZpDataService.subscriptionNotValid ||
        subscriptionStatus === "Payment Required" ||
        (subscriptionStatus && !subscriptionStatus["active"])
      ) {
        if (
          this.myUser.subscriptionId ||
          (subscriptionStatus.method &&
            subscriptionStatus.method.customerId &&
            !subscriptionStatus.active)
        ) {
          this.router.navigate(["/payment-subscription"]);
        } else if (this.myUser.userType == "professional") {
          this.router.navigate(["/payment-choose-licenses"]);
          this.sideNavBarVisibilityService.changeMessage("none");
          this.isProfessional = true;
          return;
        } else if (
          this.myUser.userType == "planHolder" ||
          this.myUser.userType == undefined
        ) {
          this.router.navigate(["/payment-choose-plan"]);
          this.isProfessional = false;
          return;
        } // Ignore admins. re: payment.
      }
    }

    if (this.myUser) {
      this.userInfo.changeMessage(JSON.stringify(this.myUser));
      this.mySharedPlans = await this.ZpDataService.getMySharedPlans(
        this.myUser["Id"]
      );
      this.hasPlan = await this.ZpDataService.getPlan(this.myUser["Id"]);
      let urlParams = this.ZpDataService.redirectParams();
      let url = this.ZpDataService.redirectUrl();
      if (url) {
        this.router.navigate([url, urlParams]);
      } else {
        if (this.myUser) {
          this.checkMfaAlways();
        }
        if (
          // Special case when plan holder is also a delegate
          !this.hasPlan &&
          this.mySharedPlans &&
          this.mySharedPlans.length > 0 &&
          this.myUser.userType == "planHolder"
        ) {
          this.sideNavBarVisibilityService.changeMessage("none");
          this.checkMfaAlways();
        }
      }
      if (
        // case if the user if a pure delegate
        this.mySharedPlans &&
        this.mySharedPlans.length > 0 &&
        !this.hasPlan && this.myUser.userType == undefined
      ) {
        console.log('userType', this.myUser.userType)
        this.sideNavBarVisibilityService.changeMessage("top");
        this.router.navigate(["/delegate-home-page"])
      } else {
        this.sideNavBarVisibilityService.changeMessage("bottom");
      }
    } else {
      this.loginFail = true;
    }
  }

  async checkMfaAlways() {
    switch (this.myUser.mfaAlways) {
      case undefined:
        await this.ZpDataService.requestMFACode();
        this.doMFA = true;
        break;
      case "Yes":
        await this.ZpDataService.requestMFACode();
        this.doMFA = true;
        break;
      case "No":
        this.sendToLocation();
        break;
    }
  }

  async resendMFA() {
    await this.ZpDataService.requestMFACode();
    this.doMFA = true;
    alert("A code has been resent to your " + (this.isSMS ? "phone" : "email"));
  }

  async onSubmit() {
    this.submitted = true;
    this.disabled = true;
    setTimeout(() => {
      this.disabled = false;
    }, 3000);
    if (this.loginForm.invalid) {
      return;
    }
    this.userIdle.startWatching();
    this.id = await this.ZpDataService.checkPassword(
      "users",
      this.loginForm.controls["userName"].value.toLowerCase(),
      this.loginForm.controls["password"].value
    );
    if (!this.id) {
      return;
    }
    if (localStorage.mstesmarker) {
      let mstesmarker = JSON.parse(localStorage.mstesmarker);
      let code =
        mstesmarker[this.loginForm.controls["userName"].value.toLowerCase()];
      if (code) {
        let result = await this.ZpDataService.confirmMFACode(code);
        if (result.success) {
          let a = await this.completeLogin();
        } else {
          delete mstesmarker[
            this.loginForm.controls["userName"].value.toLowerCase()
          ];
          localStorage.mstesmarker = JSON.stringify(mstesmarker);
          await this.ZpDataService.requestMFACode();
          this.doMFA = true;
        }
      } else {
        if (!this.doMFA) {
          await this.ZpDataService.requestMFACode();
          this.doMFA = true;
        }
      }
    } else {
      if (!this.doMFA) {
        await this.ZpDataService.requestMFACode();
        this.doMFA = true;
      }
    }
    this.submitted = false;
  }

  async confirmMFACode() {
    const code = this.mfaForm.controls["mfaCode"].value;
    if (code) {
      const result = await this.ZpDataService.confirmMFACode(code);
      if (result.success) {
        if (!localStorage.mstesmarker) {
          localStorage.mstesmarker = JSON.stringify({});
        }
        const mstesmarker = JSON.parse(localStorage.mstesmarker);
        mstesmarker[this.loginForm.controls["userName"].value.toLowerCase()] =
          code;
        localStorage.mstesmarker = JSON.stringify(mstesmarker);
      } else {
        this.MFAFail = true;
      }
      if (!this.myUser) {
        this.myUser = await this.ZpDataService.getItemUser(this.id, "users");
      }
      if (this.myUser) {
        this.sendToLocation();
      } else {
        this.onSubmit();
      }
    } else {
      this.MFAEmpty = true;
    }
  }

  sendToLocation() {
    switch (this.myUser.userType) {
      // admin
      case "admin":
        this.router.navigate(["/admin-dashboard"]);
        this.sideNavBarVisibilityService.changeMessage("none");
        break;
      case "professional":
        this.router.navigate(["/professional-home-page"]);
        this.sideNavBarVisibilityService.changeMessage("none");
        this.isProfessional = true;
        break;
      // professional manager
      case "professionalManager":
        this.router.navigate(["/professional-manager-home-page"]);
        this.sideNavBarVisibilityService.changeMessage("none");
        this.isProfessional = true;
        break;
      // plan holder
      case "planHolder":
        this.router.navigate(["/home"]);
        break;
      default:
        // Delegate doesn't have userType
        this.router.navigate(["/delegate-home-page"]);
        this.sideNavBarVisibilityService.changeMessage("none");
    }
  }

  ngOnDestroy() {
    this.sideNavBarVisibilityService.hideSideNav = false;
  }
}
